var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardAccountGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 246,
    viewBox: "0 0 388 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.837 23.2079V222.302C387.837 235.112 377.439 245.51 364.629 245.51H23.2079C10.3976 245.51 0 235.112 0 222.302V23.2079C0 10.3976 10.3976 0 23.2079 0H364.64C369.224 0 373.51 1.33273 377.094 3.64203C383.551 7.74363 387.837 14.9818 387.837 23.2079Z",
    fill: "url(#paint0_linear_835_816)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M387.834 23.2079V174.381C351.356 188.214 310.237 183.549 300.253 165.983C292.934 153.103 307.859 143.062 303.711 119.303C301.735 108.043 296.553 99.8171 289.166 92.0505C279.274 81.6069 265.406 72.0135 250.114 57.0548C240.28 47.4384 216.176 23.8628 203.032 0H364.626C369.21 0 373.496 1.33273 377.092 3.65353C383.56 7.74364 387.834 14.9703 387.834 23.2079Z",
    fill: "url(#paint1_linear_835_816)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.835 75.6091V222.302C387.835 235.112 377.449 245.498 364.639 245.498H23.2062C10.3959 245.498 0.00976562 235.112 0.00976562 222.302V109.663C6.69641 103.045 14.5205 96.8524 23.6313 91.6363C51.4119 75.701 78.2619 76.7695 130.824 79.5383C194.152 82.8702 198.61 93.7158 243.199 95.0945C261.547 95.669 276.483 94.3133 289.167 92.0499C331.918 84.3178 348.853 65.9238 383.24 74.3453C384.768 74.7244 386.296 75.138 387.835 75.6091Z",
    fill: "url(#paint2_linear_835_816)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.475 0C113.156 61.6849 62.5695 110.261 0 113.443V23.2079C0 10.3976 10.3976 0 23.2079 0H119.475Z",
    fill: "url(#paint3_linear_835_816)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M287.89 245.499H124.757L195.231 175.025C201.332 168.936 211.304 168.936 217.405 175.025L287.89 245.499Z",
    fill: "url(#paint4_linear_835_816)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M387.837 219.58V222.291C387.837 235.101 377.439 245.499 364.629 245.499H23.2079C10.3976 245.499 0 235.101 0 222.291V130.999C6.43388 127.575 13.8673 124.967 22.1969 124.048C41.4985 121.945 56.6411 129.988 74.4262 139.719C108.537 158.389 113.903 173.152 133.193 185.422C170.303 209.033 200.795 186.468 263.778 188.03C311.227 189.225 361.619 203.702 387.837 219.58Z",
    fill: "url(#paint5_linear_835_816)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M387.837 23.2079V222.302C387.837 235.112 377.439 245.51 364.629 245.51H23.2079C10.3976 245.51 0 235.112 0 222.302V23.2079C0 10.3976 10.3976 0 23.2079 0H364.64C369.224 0 373.51 1.33273 377.094 3.64203C383.551 7.74363 387.837 14.9818 387.837 23.2079Z",
    fill: "url(#paint6_linear_835_816)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9599 157.918H33.9394C31.9518 157.918 30.3203 156.286 30.3203 154.299V131.332C30.3203 129.344 31.9518 127.713 33.9394 127.713H64.9599C66.9475 127.713 68.579 129.344 68.579 131.332V154.299C68.579 156.286 66.9475 157.918 64.9599 157.918Z",
    fill: "#F6C859"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0352 153.885C44.8744 153.885 44.7135 153.793 44.6446 153.644C44.5297 153.426 44.6216 153.161 44.8399 153.047C45.4833 152.713 46.3565 152.104 46.862 151.036C47.5054 149.68 47.333 148.21 47.0688 148.083C46.9999 148.049 46.7356 148.187 46.5748 148.267C46.1612 148.485 45.5752 148.773 44.9088 148.543C44.254 148.313 43.9323 147.727 43.7829 147.451C42.7834 145.613 42.4732 140.834 43.5302 138.455C43.8863 137.663 44.3574 137.203 44.9548 137.065C45.5637 136.927 46.0578 137.18 46.4484 137.387C46.7701 137.559 46.9424 137.628 47.0343 137.571C47.4479 137.318 47.4364 135.801 46.862 134.595C46.3565 133.527 45.4833 132.918 44.8399 132.585C44.6216 132.47 44.5412 132.205 44.6446 131.987C44.7595 131.769 45.0237 131.688 45.242 131.792C46.0003 132.182 47.0458 132.918 47.6547 134.216C48.2637 135.491 48.5509 137.686 47.4824 138.329C46.9424 138.651 46.4369 138.386 46.0233 138.18C45.7131 138.019 45.4259 137.869 45.1386 137.938C44.748 138.03 44.4838 138.478 44.3229 138.835C43.3923 140.903 43.6565 145.429 44.5412 147.049C44.6906 147.325 44.8744 147.624 45.1846 147.727C45.4833 147.831 45.759 147.704 46.1612 147.497C46.5518 147.302 46.9884 147.072 47.4479 147.302C48.436 147.785 48.3785 149.922 47.6547 151.438C47.0458 152.725 46.0003 153.472 45.242 153.862C45.1731 153.874 45.1042 153.885 45.0352 153.885Z",
    fill: "#7D662D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7164 139.259H35.743C35.5017 139.259 35.2949 139.064 35.2949 138.811C35.2949 138.559 35.4902 138.363 35.743 138.363H43.7164C43.9577 138.363 44.1645 138.559 44.1645 138.811C44.1645 139.064 43.9577 139.259 43.7164 139.259Z",
    fill: "#7D662D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7164 147.244H35.743C35.5017 147.244 35.2949 147.048 35.2949 146.796C35.2949 146.543 35.4902 146.348 35.743 146.348H43.7164C43.9577 146.348 44.1645 146.543 44.1645 146.796C44.1645 147.048 43.9577 147.244 43.7164 147.244Z",
    fill: "#7D662D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3439 153.885C54.2749 153.885 54.206 153.874 54.137 153.839C53.3788 153.449 52.3333 152.713 51.7243 151.415C51.0005 149.898 50.9431 147.762 51.9311 147.279C52.3907 147.061 52.8273 147.279 53.2179 147.474C53.62 147.681 53.8958 147.807 54.1945 147.704C54.5277 147.589 54.723 147.233 54.8379 147.026C55.7225 145.406 55.9868 140.891 55.0562 138.812C54.8953 138.455 54.6196 138.007 54.2404 137.915C53.9992 137.858 53.8498 137.617 53.9073 137.387C53.9647 137.146 54.206 137.008 54.4358 137.054C55.0332 137.192 55.5042 137.663 55.8604 138.455C56.9174 140.834 56.6187 145.613 55.6076 147.451C55.4583 147.727 55.1366 148.313 54.4817 148.543C53.8154 148.773 53.2294 148.485 52.8158 148.267C52.655 148.187 52.3792 148.049 52.3218 148.083C52.0575 148.21 51.8852 149.68 52.5286 151.036C53.0341 152.104 53.9073 152.713 54.5507 153.046C54.7689 153.161 54.8494 153.426 54.746 153.644C54.6655 153.793 54.5047 153.885 54.3439 153.885Z",
    fill: "#7D662D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5727 137.49C52.3889 137.49 52.2165 137.375 52.1476 137.192C51.194 134.342 53.4229 132.148 54.1352 131.78C54.3535 131.665 54.6177 131.757 54.7326 131.976C54.8475 132.194 54.7556 132.458 54.5373 132.573C54.2156 132.734 52.1706 134.492 52.9863 136.916C53.0667 137.146 52.9403 137.398 52.7105 137.479C52.6646 137.479 52.6186 137.49 52.5727 137.49Z",
    fill: "#7D662D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6471 139.259H55.6737C55.4324 139.259 55.2256 139.064 55.2256 138.811C55.2256 138.559 55.4209 138.363 55.6737 138.363H63.6471C63.8884 138.363 64.0952 138.559 64.0952 138.811C64.0952 139.064 63.8998 139.259 63.6471 139.259Z",
    fill: "#7D662D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6471 147.244H55.6737C55.4324 147.244 55.2256 147.048 55.2256 146.796C55.2256 146.543 55.4209 146.348 55.6737 146.348H63.6471C63.8884 146.348 64.0952 146.543 64.0952 146.796C64.0952 147.048 63.8998 147.244 63.6471 147.244Z",
    fill: "#7D662D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_835_816",
    x1: 42.3858,
    y1: 274.288,
    x2: 345.454,
    y2: -28.7806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#146425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FF83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_835_816",
    x1: 257.946,
    y1: 124.673,
    x2: 378.426,
    y2: 4.19335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FF83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#146425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_835_816",
    x1: 66.4037,
    y1: 298.302,
    x2: 338.465,
    y2: 26.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#146425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FF83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_835_816",
    x1: -13.4317,
    y1: 100.007,
    x2: 103.024,
    y2: -16.4481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#146425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FF83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_835_816",
    x1: 165.542,
    y1: 286.284,
    x2: 247.106,
    y2: 204.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02FD2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FF83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_835_816",
    x1: 71.7372,
    y1: 303.64,
    x2: 271.818,
    y2: 103.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#146425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85FF83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_835_816",
    x1: 42.3858,
    y1: 274.288,
    x2: 345.454,
    y2: -28.7806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02FD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAccountGreen);
export default __webpack_public_path__ + "static/media/card_account_green.e8e21d94a029a9d0f4590a19e0d4bbd9.svg";
export { ForwardRef as ReactComponent };